module.exports = __webpack_public_path__ + "static/studio-a-rack-5a5bd1b15bdc6c0118ef0a69dfbce4dd.jpg";